import { render, staticRenderFns } from "./QrcodeBody.vue?vue&type=template&id=133cdd4e&scoped=true&"
import script from "./QrcodeBody.vue?vue&type=script&lang=js&"
export * from "./QrcodeBody.vue?vue&type=script&lang=js&"
import style0 from "./QrcodeBody.vue?vue&type=style&index=0&id=133cdd4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133cdd4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VOverlay,VProgressCircular,VSheet})
